"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.voteOption = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _big = _interopRequireDefault(require("big.js"));

var crypto = _interopRequireWildcard(require("../../crypto"));

var _types = require("../../types");

var _validateHelper = require("../../utils/validateHelper");

var _proposalType = _interopRequireDefault(require("./proposalType"));

// This is a circular dependecy; should be changed to `import type` asap
var BASENUMBER = Math.pow(10, 8);
var proposalTypeMapping = {
  0x04: "ListTradingPair",
  0x00: "Nil",
  0x01: "Text",
  0x02: "ParameterChange",
  0x03: "SoftwareUpgrade",
  0x05: "FeeChange",
  0x06: "CreateValidator",
  0x07: "RemoveValidator"
};
/**
 * VoteOption
 * @ignore
 * @example
 * OptionEmpty - 0x00
 * OptionYes - 0x01
 * OptionAbstain - 0x02
 * OptionNo - 0x03
 * OptionNoWithVeto - 0x04
 */

var voteOption = {
  OptionEmpty: 0x00,
  OptionYes: 0x01,
  OptionAbstain: 0x02,
  OptionNo: 0x03,
  OptionNoWithVeto: 0x04
};
exports.voteOption = voteOption;
var voteOptionMapping = {
  0x00: "Empty",
  0x01: "Yes",
  0x02: "Abstain",
  0x03: "No",
  0x04: "NoWithVeto"
};

var Gov = /*#__PURE__*/function () {
  /**
   * @param {Object} bncClient
   */
  function Gov(bncClient) {
    (0, _classCallCheck2["default"])(this, Gov);
    (0, _defineProperty2["default"])(this, "_bncClient", void 0);

    if (!Gov.instance) {
      this._bncClient = bncClient;
      Gov.instance = this;
    }

    return Gov.instance;
  }
  /**
   * Submit a list proposal along with an initial deposit
   * @param {Object} listParams
   * @example
   * var listParams = {
   *  title: 'New trading pair',
   *  description: '',
   *  baseAsset: 'BTC',
   *  quoteAsset: 'BNB',
   *  initPrice: 1,
   *  address: '',
   *  initialDeposit: 2000,
   *  expireTime: 1570665600,
   *  votingPeriod: 604800
   * }
   */


  (0, _createClass2["default"])(Gov, [{
    key: "submitListProposal",
    value: function () {
      var _submitListProposal = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(listParams) {
        var listTradingPairObj, description, address, title, initialDeposit, votingPeriod;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                listTradingPairObj = {
                  base_asset_symbol: listParams.baseAsset,
                  quote_asset_symbol: listParams.quoteAsset,
                  init_price: +new _big["default"](listParams.initPrice).mul(BASENUMBER).toString(),
                  description: listParams.description,
                  expire_time: new Date(listParams.expireTime).toISOString()
                };
                description = JSON.stringify(listTradingPairObj);
                address = listParams.address, title = listParams.title, initialDeposit = listParams.initialDeposit, votingPeriod = listParams.votingPeriod;
                _context.next = 5;
                return this.submitProposal(address, title, description, _proposalType["default"].ProposalTypeListTradingPair, initialDeposit, votingPeriod);

              case 5:
                return _context.abrupt("return", _context.sent);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function submitListProposal(_x) {
        return _submitListProposal.apply(this, arguments);
      }

      return submitListProposal;
    }()
    /**
     * Submit a proposal along with an initial deposit.
     * Proposal title, description, type and deposit can
     * be given directly or through a proposal JSON file.
     * @param {String} address
     * @param {String} title
     * @param {String} description
     * @param {Number} proposalType
     * @param {Number} initialDeposit
     * @param {String} votingPeriod
     * @return {Promise} resolves with response (success or fail)
     */

  }, {
    key: "submitProposal",
    value: function () {
      var _submitProposal = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(address, title, description, proposalType, initialDeposit, votingPeriod) {
        var accAddress, coins, proposalMsg, signMsg, signedTx;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accAddress = crypto.decodeAddress(address);
                coins = [{
                  denom: "BNB",
                  amount: new _big["default"](initialDeposit).mul(BASENUMBER).toString()
                }];
                votingPeriod = +new _big["default"](votingPeriod).mul(Math.pow(10, 9)).toString();
                proposalMsg = {
                  title: title,
                  description: description,
                  proposal_type: proposalType,
                  proposer: accAddress,
                  initial_deposit: [{
                    denom: "BNB",
                    amount: +new _big["default"](initialDeposit).mul(BASENUMBER).toString()
                  }],
                  voting_period: votingPeriod,
                  aminoPrefix: _types.AminoPrefix.MsgSubmitProposal
                };
                signMsg = {
                  description: description,
                  initial_deposit: coins,
                  proposal_type: proposalTypeMapping[proposalType],
                  proposer: address,
                  title: title,
                  voting_period: votingPeriod.toString()
                };
                _context2.next = 7;
                return this._bncClient._prepareTransaction(proposalMsg, signMsg, address);

              case 7:
                signedTx = _context2.sent;
                return _context2.abrupt("return", this._bncClient._broadcastDelegate(signedTx));

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function submitProposal(_x2, _x3, _x4, _x5, _x6, _x7) {
        return _submitProposal.apply(this, arguments);
      }

      return submitProposal;
    }()
    /**
     * Deposit tokens for activing proposal
     * @param {Number} proposalId
     * @param {String} address
     * @param {Array} coins
     * @example
     * var coins = [{
     *   "denom": "BNB",
     *   "amount": 10
     * }]
     */

  }, {
    key: "deposit",
    value: function () {
      var _deposit = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(proposalId, address, coins) {
        var accAddress, amount, depositMsg, signMsg, signedTx;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                accAddress = crypto.decodeAddress(address);
                (0, _validateHelper.checkCoins)(coins);
                amount = [];
                coins.forEach(function (coin) {
                  amount.push({
                    denom: coin.denom,
                    amount: +new _big["default"](coin.amount).mul(BASENUMBER).toString()
                  });
                });
                depositMsg = {
                  proposal_id: proposalId,
                  depositer: accAddress,
                  amount: amount,
                  aminoPrefix: _types.AminoPrefix.MsgDeposit
                };
                signMsg = {
                  amount: amount.map(function (coin) {
                    return {
                      denom: coin.denom,
                      amount: String(coin.amount)
                    };
                  }),
                  depositer: address,
                  proposal_id: String(proposalId)
                };
                _context3.next = 8;
                return this._bncClient._prepareTransaction(depositMsg, signMsg, address);

              case 8:
                signedTx = _context3.sent;
                return _context3.abrupt("return", this._bncClient._broadcastDelegate(signedTx));

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deposit(_x8, _x9, _x10) {
        return _deposit.apply(this, arguments);
      }

      return deposit;
    }()
    /**
     *
     * @param {Number} proposalId
     * @param {String} voter
     * @param {VoteOption} option
     */

  }, {
    key: "vote",
    value: function () {
      var _vote = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(proposalId, voter, option) {
        var accAddress, voteMsg, signMsg, signedTx;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                accAddress = crypto.decodeAddress(voter);
                voteMsg = {
                  proposal_id: proposalId,
                  voter: accAddress,
                  option: option,
                  aminoPrefix: _types.AminoPrefix.MsgVote
                };
                signMsg = {
                  option: voteOptionMapping[option],
                  proposal_id: String(proposalId),
                  voter: voter
                };
                _context4.next = 5;
                return this._bncClient._prepareTransaction(voteMsg, signMsg, voter);

              case 5:
                signedTx = _context4.sent;
                return _context4.abrupt("return", this._bncClient._broadcastDelegate(signedTx));

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function vote(_x11, _x12, _x13) {
        return _vote.apply(this, arguments);
      }

      return vote;
    }()
  }]);
  return Gov;
}();

(0, _defineProperty2["default"])(Gov, "instance", void 0);
var _default = Gov;
exports["default"] = _default;